import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { icons } from "./iconConfig";

// Default values
const default_props = {
  iconColor: "#212529",
  disabledColor: "#808080",
  size: "1.2rem",
  tooltip: null,
  tooltipClass: "",
  tooltipPlacement: "bottom",
  disabled: false,
};

const Icon = ({ name, onClick, overrides = {}, id }) => {
  const config = icons[name];

  if (!config) {
    console.warn(`Icon "${name}" not found in icons config`);
    return null;
  }

  const mergedProps = { ...default_props, ...config, ...overrides };

  const {
    icon,
    tooltip,
    // backgroundColor,
    iconColor,
    disabledColor,
    size,
    disabled,
    tooltipClass,
    tooltipPlacement,
  } = mergedProps;

  // Handle disabled state
  const activeColor = disabled ? disabledColor : iconColor;

  const style = {
    color: activeColor,
    fontSize: size || "1.2rem",
    cursor: "pointer",
    opacity: disabled ? 0.7 : 1,
    ...(mergedProps.style || {}),
  };

  const elementId = id || `${name}-icon`;

  const iconElement = (
    <FontAwesomeIcon
      id={elementId}
      icon={icon}
      style={style}
      onClick={!disabled ? onClick : undefined}
    />
  );

  // Force tooltip to always be visible if tooltip exists
  if (tooltip) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement={tooltipPlacement}
        rootClose={true}
        overlay={
          <Tooltip id={`${elementId}-tooltip`} className={tooltipClass}>
            {tooltip}
          </Tooltip>
        }
      >
        {iconElement}
      </OverlayTrigger>
    );
  }

  return iconElement;
};

export default Icon;
